module.exports = __webpack_public_path__ + "static/media/bgd_desktop_3200x1450_WIOSNA.800ceb80.svg";